var _path, _path2, _rect, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMp3 = function SvgMp3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#mp3_svg__a)",
    d: "M9 7.5A4.5 4.5 0 0 1 13.5 3H30c8.284 0 15 6.716 15 15v22.5a4.5 4.5 0 0 1-4.5 4.5h-27A4.5 4.5 0 0 1 9 40.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#C0BEBE",
    fillRule: "evenodd",
    d: "M22.5 25.5v9.128A2.25 2.25 0 1 0 24 36.75v-3.937l9-1.126v1.441a2.25 2.25 0 1 0 1.5 2.122V24zM33 27.188l-9 1.125v1.5l9-1.125z",
    clipRule: "evenodd"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25.5,
    height: 12,
    x: 3,
    y: 9,
    fill: "#FF28B7",
    rx: 4.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M6.803 12H8.83l1.395 3.398h.07L11.69 12h2.027v6h-1.594v-3.469h-.046l-1.336 3.422H9.78l-1.336-3.445h-.047V18H6.803zm7.686 6v-6h2.59q.668 0 1.169.264t.78.74q.277.479.277 1.117 0 .645-.287 1.116-.284.472-.8.727-.511.255-1.198.255h-1.546v-1.266h1.218q.288 0 .49-.1a.73.73 0 0 0 .313-.29.85.85 0 0 0 .111-.442.83.83 0 0 0-.111-.44.7.7 0 0 0-.314-.28 1.1 1.1 0 0 0-.489-.1h-.574V18zm7.77.082q-.71 0-1.26-.243a2.1 2.1 0 0 1-.861-.677 1.65 1.65 0 0 1-.317-.99h1.64a.52.52 0 0 0 .106.31q.105.135.287.211.183.076.416.076.226 0 .399-.079a.66.66 0 0 0 .27-.225.56.56 0 0 0 .093-.328.48.48 0 0 0-.111-.322.7.7 0 0 0-.314-.22 1.3 1.3 0 0 0-.465-.08h-.61v-1.124h.61q.243 0 .427-.08a.67.67 0 0 0 .29-.22.5.5 0 0 0 .103-.321.54.54 0 0 0-.085-.311.6.6 0 0 0-.246-.211.8.8 0 0 0-.36-.076 1 1 0 0 0-.4.079.66.66 0 0 0-.271.22.56.56 0 0 0-.103.322h-1.559q.003-.55.302-.973a2.03 2.03 0 0 1 .826-.662q.525-.24 1.204-.24.665 0 1.175.226.513.225.8.62.29.393.287.9.006.504-.346.826a1.5 1.5 0 0 1-.884.381v.047q.726.08 1.092.445.367.363.36.914a1.46 1.46 0 0 1-.316.935q-.316.407-.881.639-.563.231-1.298.231"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mp3_svg__a",
    x1: 9,
    x2: 45,
    y1: 45,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FAFC"
  })))));
};
export default SvgMp3;